export default __webpack_public_path__ + "static/media/channeluserimg.6bb5235d.png";